export default "__VITE_ASSET__BDCpT3Pu__"